/**
 * Metadata key marking a persisted user message as UI-authored — the app
 * talking to the agent, never typed by the user. Such messages stay in thread
 * memory (the model reads them) but are hidden from the transcript.
 *
 * Wire contract with the BE — key and values are persisted in threads and must never change.
 */
export const UI_EVENT_KEY = 'uiEvent';

/** Outcome report of proposed actions (confirmed/skipped), sent before the next typed turn. */
export const UI_EVENT_ACTION_OUTCOMES = 'action-outcomes';

/** View-state trail entry (`[ui] viewing: ...`), written by the BE when the viewed entity changes. */
export const UI_EVENT_APP_CONTEXT = 'app-context';
